module.exports = __webpack_public_path__ + "img/quadr_innova1.265376b0.png";